import { SET_SERVICE_LEVELS } from './service-levels.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

export const namespace = 'serviceLevels';

export const reducer = (state = [], action) => {
  switch (action.type) {
    case SET_SERVICE_LEVELS: {
      return action.data;
    }
    case APP_INITIALIZATION: {
      return action?.initialData?.serviceLevels || [];
    }
    default: {
      return state;
    }
  }
};
